export const CATEGORY = {
  GET: 'GET_CATEGORY',
  GET_SUCCESS: 'GET_CATEGORY_SUCCESS',
  GET_FAILURE: 'GET_CATEGORY_FAILURE',
}
